<template>
  <div :class="scope.clsPrefix">
    <div class="detail-container">
      <div class="detail-header">
        <div class="detail-title">任务详情</div>
        <div class="detail-close" style="display:none" @click="$emit('close')"><i class="el-icon-close"></i></div>
      </div>
      <div class="detail-form">
        <div class="form-item">
          <label class="form-label">任务标题</label>
          <el-input v-model="detailData.title" disabled size="medium" class="form-input"></el-input>
        </div>
        <div class="form-item">
          <label class="form-label">执行者</label>
          <el-input v-model="detailData.agent" disabled size="medium" class="form-input"></el-input>
        </div>
        <div class="form-item">
          <label class="form-label">任务类型</label>
          <el-select v-model="detailData.taskType" disabled size="medium" class="form-select">
            <el-option label="文字消息" value="text"></el-option>
            <el-option label="报告" value="report"></el-option>
            <el-option label="提醒" value="reminder"></el-option>
          </el-select>
        </div>
        <div class="form-item">
          <label class="form-label">报告类型</label>
          <el-radio-group v-model="detailData.reportType" disabled>
            <el-radio label="market">市场行情</el-radio>
            <el-radio label="competitor">竞品动态</el-radio>
            <el-radio label="policy">政策法规</el-radio>
          </el-radio-group>
        </div>
        <div class="form-item">
          <label class="form-label">报告类别</label>
          <el-radio-group v-model="detailData.category" disabled>
            <el-radio label="internal">经营报告</el-radio>
            <el-radio label="external">咨询报告</el-radio>
          </el-radio-group>
        </div>
        <div class="form-item">
          <el-checkbox v-model="detailData.decision" disabled>生成待办</el-checkbox>
        </div>
        <div class="form-item" v-if="detailData.decision">
          <label class="form-label">生成待办的条件或指令</label>
          <el-input type="textarea" v-model="detailData.decisionCondition" disabled :rows="3" class="form-textarea"></el-input>
        </div>
        <div class="form-item">
          <label class="form-label">cron表达式</label>
          <el-input v-model="detailData.cronExpression" disabled size="medium" class="form-input"></el-input>
        </div>
        <div class="form-item">
          <label class="form-label">是否启用</label>
          <el-switch v-model="detailData.enabled" disabled active-text="启用" inactive-text="禁用"></el-switch>
        </div>
        <div class="form-item">
          <label class="form-label">来源</label>
          <el-select v-model="detailData.source" disabled size="medium" class="form-select">
            <el-option label="手动" value="manual"></el-option>
            <el-option label="决策智能体" value="decision"></el-option>
            <el-option label="对话" value="conversation"></el-option>
          </el-select>
        </div>
        <div class="form-item">
          <label class="form-label">任务内容</label>
          <el-input type="textarea" v-model="detailData.content" disabled :rows="4" class="form-textarea"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getJobDetailApi } from '@/api/agentAuth'

export default {
  name: 'TaskDetail',
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-task-detail'
      },
      detailData: {
        id: '',
        title: '',
        agent: '',
        taskType: '',
        cronExpression: '',
        enabled: true,
        content: '',
        source: '',
        reportType: 'market',
        category: 'internal',
        decision: false,
        decisionCondition: ''
      },
      loading: false
    }
  },
  watch: {
    id(newVal) {
      if (newVal) {
        this.fetchDetail(newVal)
      }
    }
  },
  mounted() {
    if (this.id) {
      this.fetchDetail(this.id)
    }
  },
  methods: {
    async fetchDetail(id) {
      this.loading = true
      try {
        const res = await getJobDetailApi(id)
        if (res && res.data) {
          const data = res.data
          let reportType = 'market'
          let category = 'internal'
          let decision = false
          let decisionCondition = ''
          if (data.reportConfig) {
            try {
              const rc = typeof data.reportConfig === 'string' ? JSON.parse(data.reportConfig) : data.reportConfig
              reportType = rc.reportType || 'market'
              category = rc.category || 'internal'
              decision = rc.decision || false
              decisionCondition = rc.decisionCondition || ''
            } catch (e) {
              // ignore parse error
            }
          }
          this.detailData = {
            id: data.id || '',
            title: data.name || '',
            agent: data.agentName || '',
            taskType: data.taskType || '',
            cronExpression: data.cronExpression || '',
            enabled: data.enabled !== undefined ? data.enabled : true,
            content: data.triggerMessage || '',
            source: data.source || '',
            reportType,
            category,
            decision,
            decisionCondition
          }
        }
      } catch (error) {
        console.error('获取任务详情失败:', error)
        this.detailData = {
          id: '',
          title: '获取详情失败',
          agent: '',
          taskType: '',
          cronExpression: '',
          enabled: false,
          content: '',
          source: ''
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-task-detail";
.#{$class-prefix} {
  height: 100%;
  padding: 24px;
  background: #fff;
  overflow-y: auto;
  border-radius: 10px;
  scrollbar-width: thin;
  scrollbar-color: #aaa transparent;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
    border-radius: 2px;
  }
}
.detail-container {
  display: flex;
  flex-direction: column;
}
.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.detail-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  font-family: PingFangSC-Medium;
}
.detail-close {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  color: #999;
  transition: all 0.2s;
  &:hover {
    background: #F0F2FF;
    color: #4A5FF3;
  }
}
.detail-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  font-family: PingFangSC-Medium;
}
.form-input {
  width: 400px;
}
.form-textarea {
  width: 400px;
}
.form-select {
  width: 400px;
}
</style>
